import { SnackbarProvider } from 'notistack';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ScrollToTop } from './Hooks/usePreventScrolling';
import Home from './MainWebsite/Pages/Home/Home';
import './App.css';

import ContactPage from './MainWebsite/Pages/ContactPage/ContactPage';
import PrivacyPolicy from './MainWebsite/Pages/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from './MainWebsite/Pages/TermsOfService/TermsOfService';
import ServicePage from './MainWebsite/Pages/ServicePages/ServicePage';
import { SERVICE_PAGES } from './MainWebsite/Pages/ServicePages/serviceData';
import MobileActionBar from './MainWebsite/GlobalComp/MobileActionBar/MobileActionBar';

// Everything inside the router. The browser wraps it in BrowserRouter (below);
// scripts/prerender.js wraps it in StaticRouter to render each page to HTML at build time.
export function AppContent() {
  return (
    <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
      <ScrollToTop />

      <Routes>
        <Route path='/' element={<Home />} ></Route>
        <Route path='/contact' element={<ContactPage />} ></Route>
        <Route path='/privacy-policy' element={<PrivacyPolicy />} ></Route>
        <Route path='/terms-of-service' element={<TermsOfService />} ></Route>
        {SERVICE_PAGES.map((page) => (
          <Route key={page.path} path={page.path} element={<ServicePage page={page} />} ></Route>
        ))}

        {/* Unknown URLs still show the homepage, but are kept out of search results */}
        <Route path='*' element={<><Helmet><meta name="robots" content="noindex,follow" /></Helmet><Home /></>} ></Route>
      </Routes>

      <MobileActionBar />
    </SnackbarProvider>
  );
}

// Every route that gets its own pre-rendered HTML file.
export const PRERENDER_ROUTES = [
  '/',
  '/contact',
  '/privacy-policy',
  '/terms-of-service',
  ...SERVICE_PAGES.map((page) => page.path),
];

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
